import React, { useState } from "react";

// intl imports
import { FormattedDate } from "react-intl";

// material-ui imports
import { TextField, IconButton } from "@material-ui/core";
import { TableCell, TableRow } from "@material-ui/core";

// internal UI components
import DeleteIcon from "../../common/icons/deleteIcon";

// Eventually will support description edits and name edits for files that are already uploaded.
// For now it's just a row for files that are to-be uploaded
const AttachmentRowEdit = (props) => {
    const { file, onChange, editing } = props;
    const [fileEntry, setFileEntry] = useState(Object.assign({}, file));

    const fileName = editing ? fileEntry?.fileNameNoExt || "" : fileEntry?.fileName || "";
    const handleChangeName = (event) => {
        let newFileEntry = { ...fileEntry };
        newFileEntry.fullFileName = event.target.value.trim() + "." + fileEntry.extension;

        if (editing) newFileEntry.fileNameNoExt = event.target.value.trim();
        else newFileEntry.fileName = event.target.value.trim();

        update(newFileEntry);
    };
    const handleChangeDescription = (event) => {
        let newFileEntry = { ...fileEntry };
        newFileEntry.fileDescription = event.target.value;
        update(newFileEntry);
    };

    const update = (newFileEntry) => {
        if (editing) {
            newFileEntry.dirty = true;
        }
        setFileEntry(newFileEntry);
        onChange(newFileEntry);
    };
    const mapDrawing = fileName.includes("mapDrawing") && file.fileName.includes(".png");
    const sketchDrawing = fileName.includes("sketchDrawing") && file.fileName.includes(".png");

    return (
        <TableRow>
            <TableCell align="left">
                <TextField
                    disabled={mapDrawing || sketchDrawing}
                    variant="outlined"
                    fullWidth
                    defaultValue={fileName}
                    error={!fileName.trim()}
                    InputProps={{
                        inputProps: { maxLength: 255 },
                    }}
                    onChange={handleChangeName}
                />
            </TableCell>
            <TableCell align="left">{file.fileType}</TableCell>
            <TableCell align="left">{file.uploadedBy}</TableCell>
            <TableCell align="left">
                <FormattedDate
                    value={file.createdDateTime}
                    year="numeric"
                    month="long"
                    day="2-digit"
                    hour="numeric"
                    minute="numeric"
                    hour12={false}
                />
            </TableCell>
            <TableCell align="left">
                <TextField
                    disabled={mapDrawing || sketchDrawing}
                    variant="outlined"
                    fullWidth
                    defaultValue={file.fileDescription}
                    InputProps={{
                        inputProps: { maxLength: 255 },
                    }}
                    onChange={handleChangeDescription}
                />
            </TableCell>
            <TableCell align="center">
                {props.editing && (
                    <IconButton
                        disabled={mapDrawing || sketchDrawing}
                        style={{
                            padding: "unset",
                        }}
                        onClick={props.onRemove}>
                        <DeleteIcon />
                    </IconButton>
                )}
            </TableCell>
        </TableRow>
    );
};

export default AttachmentRowEdit;
